import { useState, useEffect } from 'react';
import authService from '../services/authService';
import { User } from '../types/api';

export function useCurrentUser() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  
  const fetchUser = async () => {
    try {
      setLoading(true);
      const userData = await authService.getCurrentUser();
      setUser(userData);
      setError(null);
    } catch (err) {
      console.error('Error fetching user data:', err);
      setError(err as Error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    if (authService.isAuthenticated()) {
      fetchUser();
    } else {
      setLoading(false);
      setUser(null);
    }
  }, []);
  
  return { user, loading, error, refetch: fetchUser };
} 